import type { SceneModule } from '../_shared/types'
import RankingReveal from './RankingReveal'
import { RankingRevealEditor } from './Editor'
import { render } from './svgRender'
import { RankingRevealComposition } from './Composition'

export const module: SceneModule = {
  id: 'ranking-reveal',
  Component: RankingReveal,
  Composition: RankingRevealComposition,
  Editor: RankingRevealEditor,
  svgRender: render,
}
